import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchLocalizationsList } from "src/Pages/Company/OrganizationStructure/api";
import { UseLocalizationListParams } from "src/Pages/Company/OrganizationStructure/Localizations/localizations.models";

export const useLocalizationsList = ({
  companyId,
  structureId,
  page,
  size,
  sort,
  filters,
  enabled = true,
}: UseLocalizationListParams) =>
  useQuery({
    enabled: enabled && !!companyId && !!structureId,
    queryKey: [
      "localizations-list",
      companyId,
      structureId,
      page,
      size,
      sort,
      filters,
    ],
    queryFn: () =>
      fetchLocalizationsList({
        companyId,
        structureId,
        page,
        size,
        sort,
        filters,
      }),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
